import { render } from "./AdminCitiesComponent.vue?vue&type=template&id=5a23f81d"
import script from "./AdminCitiesComponent.vue?vue&type=script&lang=js"
export * from "./AdminCitiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__